import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "skip-back",
  "use": "skip-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"skip-back\">\n<path d=\"M19,21c-0.2,0-0.4-0.1-0.6-0.2l-10-8C8.1,12.6,8,12.3,8,12s0.1-0.6,0.4-0.8l10-8c0.3-0.2,0.7-0.3,1.1-0.1\n\tC19.8,3.3,20,3.6,20,4v16c0,0.4-0.2,0.7-0.6,0.9C19.3,21,19.1,21,19,21z M10.6,12l7.4,5.9V6.1L10.6,12z\" />\n<path d=\"M5,20c-0.6,0-1-0.4-1-1V5c0-0.6,0.4-1,1-1s1,0.4,1,1v14C6,19.6,5.6,20,5,20z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol